import { object, string } from "yup";

export const webhookSchema = object({
  Dev_Webhook_Url: string()
    .url("Endpoint must be a valid URL")
    .matches(/^https:\/\/.*/, "Endpoint must start with 'https://'")
    .required("Endpoint is required"),
  Dev_Webhook_Signing_Key: string()
    .min(6, "HMAC Secret must be between 6 and 50 characters in length")
    .max(50, "HMAC Secret must be between 6 and 50 characters in length")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]+$/,
      "HMAC Secret must include a combination of (a-z), (A-Z), (0-9)"
    )
    .required("HMAC is required"),
});
